import { RETRIEVE_SERVICE_CATEGORIES } from '../actions/types';
const initialState = { items: [], totalItems: 0, totalPages: 1, currentPage: 1 };

export default function serviceCategoryReducer(state = initialState, action) {
    const { type, payload } = action;
    if (type === RETRIEVE_SERVICE_CATEGORIES) {
        return { ...payload, items: payload.data };
    }
    return state;
}
